import type * as z from 'zod';

import { companyQuerySchema } from '../../../companies/shared/schemas';

export const clientQuerySchemaSubsidiesLinker = companyQuerySchema.pick({
  id: true,
  name: true,
  contacts: true,
  addresses: true,
  status: true,
  logo: true,
  account_number: true,
  exempt: true,
  tax_id: true,
});

export type ClientQuerySchemaSubsidiesLinker = z.infer<typeof clientQuerySchemaSubsidiesLinker>;

export const clientQuerySchemaAgreementsLinker = companyQuerySchema.pick({
  partner: true,
  brand: true,
  domains: true,

  id: true,
  name: true,
  contacts: true,
  addresses: true,
  status: true,
  logo: true,
  account_number: true,
  exempt: true,
  tax_id: true,
});

export type CompanyQuerySchemaAgreementsLinker = z.infer<typeof clientQuerySchemaAgreementsLinker>;
